import React, { memo } from 'react';
import { Handle, Position } from 'reactflow';

export default memo(({ data, isConnectable }) => {
    return (
        <>
            <div className="nodeTopLeft" dangerouslySetInnerHTML={{__html: data.topLeftText??''}} style={data.topLeftStyle}/>
            <div className="nodeTopRight" dangerouslySetInnerHTML={{__html: data.topRightText ?? ''}} style={data.topRightStyle}/>
            <Handle
                type="target"
                id="target-top-middle"
                position={Position.Top}
                style={{opacity: "0"}}
                isConnectable={isConnectable}
            />
            <Handle
                type="target"
                id="target-top-25"
                position={Position.Top}
                style={{opacity: "0", left: "75%"}}
                isConnectable={isConnectable}
            />
            <Handle
                type="target"
                id="target-left-10"
                position={Position.Left}
                style={{opacity: "0", top: "10%"}}
                isConnectable={isConnectable}
            />
            <Handle
                type="target"
                id="target-left-middle"
                position={Position.Left}
                style={{opacity: "0"}}
                isConnectable={isConnectable}
            />
            <Handle
                type="target"
                id="target-right-middle"
                position={Position.Right}
                style={{opacity: "0"}}
                isConnectable={isConnectable}
            />
            <Handle
                type="target"
                id="target-bottom-middle"
                position={Position.Bottom}
                style={{opacity: "0"}}
                isConnectable={isConnectable}
            />
            <div>
                {data.label}
            </div>
            <Handle
                type="source"
                id="source-top-25"
                position={Position.Top}
                style={{opacity: "0", left: "75%"}}
                isConnectable={isConnectable}
            />
            <Handle
                type="source"
                id="source-bottom-25"
                position={Position.Bottom}
                style={{opacity: "0", left: "75%"}}
                isConnectable={isConnectable}
            />
            <Handle
                type="source"
                id="source-top-middle"
                position={Position.Top}
                style={{opacity: "0"}}
                isConnectable={isConnectable}
            />
            <Handle
                type="source"
                id="source-left-middle"
                position={Position.Left}
                style={{opacity: "0"}}
                isConnectable={isConnectable}
            />
            <Handle
                type="source"
                id="source-right-middle"
                position={Position.Right}
                style={{opacity: "0"}}
                isConnectable={isConnectable}
            />
            <Handle
                type="source"
                id="source-bottom-middle"
                position={Position.Bottom}
                style={{opacity: "0"}}
                isConnectable={isConnectable}
            />
        </>
    );
});
